import { render, staticRenderFns } from "./production-order-body-table.vue?vue&type=template&id=44567999&scoped=true"
import script from "./production-order-body-table.vue?vue&type=script&lang=js"
export * from "./production-order-body-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44567999",
  null
  
)

export default component.exports